import styled from 'styled-components';
import { DESKTOP_BREAKPOINT } from '../../utils';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
`;

export const Dashboard = styled.div`
display: grid;
	gap: 24px;
	margin-bottom: 32px;
	grid-template-columns: repeat(3, 1fr);

	  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr); /* 2 por linha em tablets */
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr; /* 1 por linha em mobile */
  }
`;

export const TitleContainer = styled.div`
	display: grid;
	column-gap: 64px;
	align-items: center;
	border-bottom: 1px solid ${({ theme }) => theme.colors.neutral.grey};
	padding-bottom: 16px;

	& h1 {
		${({ theme }) => theme.typography.headlines.h5};
		justify-self: start;
	}

	& .desktop-title {
		display: inline;
	}

	@media (max-width: ${DESKTOP_BREAKPOINT}px) {
		column-gap: 0;
		row-gap: 16px;

		& .desktop-title {
			display: none;
		}

		& h1 {
			justify-self: start;
			grid-row: 1;
			grid-column: 1;
		}

		& form {
			grid-row: 2;
			grid-column: 1 / 3;
		}

		& a {
			justify-self: end;
			grid-row: 1;
			grid-column: 2;
		}
	}
`;

export const TableContainer = styled.div`
	width: 100%;
	padding: 24px;
	border-radius: 12px;
	background-color: ${({ theme }) => theme.colors.neutral.white};
`;

export const ActionsContainer = styled.div`
	display: flex;
	gap: 4px;
`;

export const BestOfferContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;

	& button {
		all: unset;
		color: ${({ theme }) => theme.colors.primary.medium};
		cursor: pointer;
	}
`;

export const TableWrapper = styled.div`
	overflow-x: auto;
`;

export const TagsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const PixContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 100%;
	overflow-wrap: anywhere;

	> p {
		margin-top: 10px;
	}
`;

export const PixCopyPasteConfirm = styled.p`
	color: red;
	font-weight: bold;
`;

export const CopiaECola = styled.p`
	border: 1px solid;
`;

export const ButtonContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 16px;
`;

export const HalfLine = styled.div``;

export const Form = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: 20px;

	@media (min-width: ${DESKTOP_BREAKPOINT}px) {
		grid-template-columns: repeat(2, 1fr);

		${HalfLine} {
			grid-column: span 1;
		}
	}
`;

export const NoData = styled.div`
	text-align: center;
	padding: 50px;
`;